﻿<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #selectionSummary>
      <div class="total-card">
        <p class="label">{{ hasSelection ? 'Seleccionadas' : 'Inversiones' }} <strong>{{ totals.count }}</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Total <strong>{{ totals.total | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pagado <strong>{{ totals.paid | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pendiente <strong>{{ totals.pending | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" placeholder="Buscar proveedor, descripción, referencia…" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-real-state-investment-detail
        [row]="row"
        [version]="detailVersion"
        (changed)="reload()"
        (edit)="edit(row)">
      </app-real-state-investment-detail>
    </ng-template>
  </div>
</div>
